import Loader from "components/shared/Loader";
import useApp from "hooks/useApp";
import { useState } from "react";
import classNames from "utilities/ClassNames";

export default function ResetTag({
  selectedTag,
  setSelectedTag,
  resetTagById,
}: any) {
  const { isScaled } = useApp();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(false);
  const handleReset = async () => {
    setLoading(true);
    const result = await resetTagById(selectedTag.value.id);
    if (result.message === "success") {
      return setSelectedTag({ action: "", value: null });
    } else {
      setError(true);
    }
    setLoading(false);
  };

  return (
    <>
      {selectedTag.action === "reset" && (
        <div className="fixed inset-0 z-10 w-full h-screen">
          <div
            onClick={() => setSelectedTag({ action: "", value: null })}
            className={classNames(
              isScaled ? "h-[2000px]" : "h-full",
              "absolute z-20 inset-0 w-full bg-black/70"
            )}
          />

          {!loading && (
            <div className="w-full h-auto bg-dark p-3 rounded-md z-30 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:max-w-[300px]">
              <div className="flex flex-col gap-5">
                <div className="flex justify-center items-center flex-col gap-10 p-3 text-center">
                  <p className={classNames(isScaled ? "text-2xl" : "")}>
                    Are you sure you want to reset this tag
                  </p>
                  <div className="flex gap-5">
                    <button
                      className="btn-sec"
                      onClick={() =>
                        setSelectedTag({ action: "", value: null })
                      }
                    >
                      cancel
                    </button>
                    <button className="btn-danger" onClick={handleReset}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {error && (
            <div className="w-full h-auto bg-dark p-3 rounded-md z-30 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:max-w-[300px]">
              <div className="flex flex-col gap-5">
                <p>Failed to reset tag</p>
                <button className="btn-danger" onClick={handleReset}>
                  Try again
                </button>
              </div>
            </div>
          )}

          {loading && (
            <div className="w-full h-full grid place-content-center relative z-30">
              <Loader />
            </div>
          )}
        </div>
      )}
    </>
  );
}
